import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will contact you shortly.');
    setFormData({ name: '', email: '', phone: '', service: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            We're here to help — 24/7 support across the UAE
          </p>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h6>Office Address</h6>
                  <p>Deira,Dubai</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h6>Phone</h6>
                  <p>+971 501077344</p>
                  <p>+971 501073768</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h6>Email</h6>
                  <p>info@barqtransport.com</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="contact-form">
              <h5>Get a Quick Quote</h5>
              <div>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Your Name"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Your Email"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Phone Number"
                  />
                </div>
                <div className="mb-3">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Service</option>
                    <option value="staff">Staff Transport</option>
                    <option value="school">School Transport</option>
                    <option value="tour">City Tour</option>
                    <option value="airport">Airport Transfer</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <button onClick={handleSubmit} className="btn btn-gold w-100">
                  Submit Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;